export default {"src":"/_next/static/media/icone-quark.cbc5c62e.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};